"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCBDValueFromMetaData = exports.getTHCValueFromMetaData = exports.getValueFromMetaData = exports.convertStrMetaDataToNumber = exports.isNullOrUndefined = void 0;
const products_1 = require("@getgreenline/products");
const isNullOrUndefined = (value) => {
    return value === null || value === undefined;
};
exports.isNullOrUndefined = isNullOrUndefined;
const convertStrMetaDataToNumber = ({ metaData, key, }) => {
    return (0, exports.isNullOrUndefined)(metaData[key]) ? null : Number(metaData[key]);
};
exports.convertStrMetaDataToNumber = convertStrMetaDataToNumber;
const getValueFromMetaData = (metaData, rangeKey, key) => {
    return metaData[products_1.MetaDataModels.MetaDataReservedKeys.SHOW_MAX_MIN] === 'true'
        ? (0, exports.convertStrMetaDataToNumber)({
            key: rangeKey,
            metaData,
        })
        : (0, exports.convertStrMetaDataToNumber)({
            key,
            metaData,
        });
};
exports.getValueFromMetaData = getValueFromMetaData;
const getTHCValueFromMetaData = (metaData, rangeLimit) => {
    const rangeKey = rangeLimit === 'max'
        ? products_1.MetaDataModels.MetaDataReservedKeys.MAX_THC
        : products_1.MetaDataModels.MetaDataReservedKeys.MIN_THC;
    return (0, exports.getValueFromMetaData)(metaData, rangeKey, products_1.MetaDataModels.MetaDataReservedKeys.THC);
};
exports.getTHCValueFromMetaData = getTHCValueFromMetaData;
const getCBDValueFromMetaData = (metaData, rangeLimit) => {
    const rangeKey = rangeLimit === 'max'
        ? products_1.MetaDataModels.MetaDataReservedKeys.MAX_CBD
        : products_1.MetaDataModels.MetaDataReservedKeys.MIN_CBD;
    return (0, exports.getValueFromMetaData)(metaData, rangeKey, products_1.MetaDataModels.MetaDataReservedKeys.CBD);
};
exports.getCBDValueFromMetaData = getCBDValueFromMetaData;
//# sourceMappingURL=metaDataHelpers.js.map